import React from 'react';
import './index.css';
import { StepIndicatorProps } from '../../redux/AllocationRequest';

export const StepIndicator: React.FC<StepIndicatorProps> = ({ current }) => {
  return (
    <div className="step-indicator">
      {[1, 2, 3, 4].map((n, i) => (
        <div key={n} className="step-item">
          <div className={`step-circle ${
            n < current ? 'step-circle-completed' : 
            n === current ? 'step-circle-current' : 
            'step-circle-upcoming'
          }`}>
            {n < current ? "✓" : n}
          </div>
          {i < 3 && (
            <div className={`step-line ${
              n < current ? 'step-line-completed' : 'step-line-upcoming'
            }`} />
          )}
        </div>
      ))}
    </div>
  );
};